import { Upload, message } from "antd";
import PropTypes from "prop-types";

import { Types } from "scripts/settings";
import Resources from "scripts/resources";

const Component = ({ onChange, value }) => {
  const handleUpload = (options) => {
    const { file } = options;

    if (Types.uploadVideoFormats.indexOf(file.type) >= 0) {
      if (file.size < parseInt(process.env.REACT_APP_VIDEO_SIZE_LIMIT)) {
        onChange(file);
      } else {
        message.error(Resources.uploadErros?.size);
      }
    } else {
      message.error(Resources.uploadErros?.extension);
    }
  };

  const uploadOpt = {
    showUploadList: false,
    customRequest: handleUpload,
  };

  return (
    <Upload {...uploadOpt} className="sp-upload-video">
      {value?.name || <i className="fa fa-plus icon" />}
    </Upload>
  );
};

Component.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
};

export default Component;
